import React from 'react';


class UseCaseCard extends React.Component {

  handleShowMeClicked = () => {
    this.props.onAction('SHOW_ME', this.props.useCaseId);
  }

  handleContactMeClicked = () => {
    this.props.onAction('CONTACT_ME', this.props.useCaseId);
  }

  handleShowVideoClicked = () => {
    this.props.onAction('PLAY_VIDEO', this.props.useCaseId);
  }

  getButtons = () => {
    const buttons = [];
    if (this.props.actions.hasWalkthrough && infaWalkMe.loaded) {
      buttons.push(<button key='walkthrough' onClick={this.handleShowMeClicked}>{this.props.content.show}</button>);
    }
    buttons.push(<button key='contact' onClick={this.handleContactMeClicked}>{this.props.content.contact}</button>);
    if (this.props.actions.hasVideo) {
      buttons.push(<button key='video' onClick={this.handleShowVideoClicked}>{this.props.content.video}</button>);
    }
    return buttons;
  }


  render() {
    return (
      <div className='use-case-card card'>
        <div className='recommended-banner'></div>
        <div className='use-case-card-title'>
          {this.props.title}
        </div>
        <p>{this.props.description}</p>
        <div className='use-case-card-buttons-group'>
          {this.getButtons()}
        </div>
      </div>
    );
  }
}

export default UseCaseCard;


